export const Card: React.FC<{ children?: React.ReactNode }> = ({
    children,
}) => (
    <div className="bg-surface-level-one rounded p-4 sm:p-6 border border-border border-opacity-5">
        {children}
    </div>
);
